var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgWidgetDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1485_2506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.73244e-07 1.17345C0.434197 0.806378 0.838215 0.464692 1.30843 0.0663845C4.46367 3.16694 7.72113 6.36707 11.0214 9.61015C14.3052 6.38562 17.5558 3.19427 20.8084 -9.85618e-07C21.2075 0.408069 21.5853 0.794662 22 1.21835C18.3707 4.7836 14.7267 8.36349 11.0243 12C7.34826 8.38985 3.69555 4.80312 -4.73244e-07 1.17345Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1485_2506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 22,
    fill: "white",
    transform: "translate(0 12) rotate(-90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetDown);
export default __webpack_public_path__ + "static/media/widget-down.aa30c092.svg";
export { ForwardRef as ReactComponent };